import modal from '@/utils/modal'
import CommentActionsModal from './index.vue'

export default function openCommentActionsModal(comment) {
    const m = modal.create(CommentActionsModal, true, { persistent: false });
    m.app.setComment(comment);
}
